import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { WhatsAppTestimonials } from '../components/WhatsAppTestimonials';
import { CheckIcon, XIcon, BookOpenIcon, CalendarIcon, FileTextIcon, BatteryChargingIcon, BrainIcon, MoonIcon, ZapIcon, ShieldCheckIcon, DownloadIcon, StarIcon, HeartCrackIcon, FrownIcon, AlertCircleIcon, SunriseIcon, SparklesIcon, HeartIcon, CoffeeIcon, SmileIcon, ArrowRightIcon, TargetIcon, GiftIcon, LayoutDashboardIcon, RepeatIcon, ListChecksIcon, BadgeCheckIcon, TagIcon, LockIcon, CheckCircle2Icon, BookIcon } from 'lucide-react';
export function LandingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Countdown timer — 10 minutes from first visit (persisted in sessionStorage)
  const [timeLeft, setTimeLeft] = useState({
    minutes: 9,
    seconds: 59
  });
  useEffect(() => {
    const STORAGE_KEY = 'dpc_offer_end_time_10min';
    let endTime = sessionStorage.getItem(STORAGE_KEY);
    if (!endTime) {
      endTime = String(Date.now() + 10 * 60 * 1000);
      sessionStorage.setItem(STORAGE_KEY, endTime);
    }
    const end = parseInt(endTime, 10);
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) {
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const minutes = Math.floor(diff / (1000 * 60) % 60);
      const seconds = Math.floor(diff / 1000 % 60);
      setTimeLeft({
        minutes,
        seconds
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <div className="w-full bg-[#0F1B2D] font-['Inter']" data-id="element-30">
      {/* Top Trust Banner - Main */}
      <div className="w-full bg-gradient-to-r from-[#D8B36A] via-[#F5B461] to-[#D8B36A] relative z-50 overflow-hidden group" data-id="element-31">
        {/* Shine effect */}
        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-[shimmer_3s_infinite] skew-x-12" data-id="element-32"></div>

        <div className="max-w-6xl mx-auto px-4 py-2 md:py-2.5 relative z-10" data-id="element-33">
          <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-12 font-bold text-[#0F1B2D] tracking-widest uppercase" data-id="element-34">
            <div className="flex items-center gap-2" data-id="element-35">
              <CheckCircle2Icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#0F1B2D]" strokeWidth={2.5} data-id="element-36" />
              <span className="text-[10px] md:text-[11px]" data-id="element-37">
                Acceso inmediato después de la compra
              </span>
            </div>

            <div className="hidden md:block w-1 h-1 rounded-full bg-[#0F1B2D]/30" data-id="element-38"></div>

            <div className="flex items-center gap-2" data-id="element-39">
              <LockIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#0F1B2D]" strokeWidth={2.5} data-id="element-40" />
              <span className="text-[10px] md:text-[11px]" data-id="element-41">
                Pago 100% seguro
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Secondary Trust Banner - Smaller */}
      <div className="w-full bg-[#FAF6F0] border-b border-gray-200 shadow-[0_2px_10px_rgba(0,0,0,0.03)] relative z-40" data-id="element-42">
        <div className="max-w-6xl mx-auto px-4 py-1 md:py-1" data-id="element-43">
          <div className="flex flex-row items-center justify-center gap-4 md:gap-8 font-bold text-gray-400 tracking-[0.2em] uppercase" data-id="element-44">
            <div className="flex items-center gap-1.5" data-id="element-45">
              <BookIcon className="w-2.5 h-2.5 text-[#F5B461]" strokeWidth={2.5} data-id="element-46" />
              <span className="text-[8px] md:text-[9px]" data-id="element-47">Ebook Digital</span>
            </div>

            <div className="w-px h-2.5 bg-gray-300" data-id="element-48"></div>

            <div className="flex items-center gap-1.5" data-id="element-49">
              <div className="relative" data-id="element-50">
                <ZapIcon className="w-2.5 h-2.5 text-[#F5B461] relative z-10" strokeWidth={2.5} data-id="element-51" />
                <div className="absolute inset-0 bg-[#F5B461] blur-[2px] opacity-40 animate-pulse" data-id="element-52"></div>
              </div>
              <span className="text-[8px] md:text-[9px]" data-id="element-53">
                Descarga Inmediata
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="min-h-screen bg-gradient-to-b from-[#FFFFFF] to-[#FAF6F0] text-[#1a2942] px-6 py-16 md:py-24 relative overflow-hidden" data-id="element-54">
        {/* Soft background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#F5B461]/10 rounded-full blur-3xl pointer-events-none" data-id="element-55"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-56">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-57">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-58">
              <h1 className="font-['Fraunces'] text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-[#1a2942]" data-id="element-59">
                Lográ que tu hijo con TDAH o TEA se duerma en menos de 20
                minutos en solo 7 noches.
              </h1>
              <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-60">
                Sin gritos, sin pantallas y sin crisis por el cambio de rutina.
                Aplicá el Método D.P.C. y sus 120 ejercicios sensoriales para
                regular el sistema nervioso y transformar la hiperactividad en
                descanso profundo.
              </p>
              <motion.a href="https://www.energiaplena.com/cart/42798800404567:1" target="_blank" rel="noopener noreferrer" animate={{
              y: [0, -8, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="relative inline-flex items-center justify-center bg-gradient-to-r from-[#F5B461] to-[#f7c47d] text-[#0F1B2D] px-8 py-4 rounded-xl font-bold text-lg shadow-[0_0_40px_rgba(245,180,97,0.4)] hover:shadow-[0_0_60px_rgba(245,180,97,0.6)] transition-shadow overflow-hidden group" data-id="element-61">
                {/* Shine effect */}
                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-62"></div>
                <span className="relative z-10 flex items-center gap-2" data-id="element-63">
                  ¡QUIERO EL MÉTODO D.P.C. AHORA!
                </span>
              </motion.a>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            rotate: -5
          }} animate={{
            opacity: 1,
            scale: 1,
            rotate: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="flex justify-center relative" data-id="element-64">
              <div className="absolute inset-0 bg-[#F5B461]/20 blur-3xl rounded-full transform scale-90" data-id="element-65"></div>
              <img src="https://cdn.magicpatterns.com/uploads/7tZbt7STxx3VEfanAvVuEB/imagen_portada_nueva_mejorada.png" alt="Método D.P.C. Ebook Cover" className="w-full max-w-md shadow-[0_20px_50px_rgba(26,41,66,0.15)] rounded-lg transform hover:rotate-2 transition-transform duration-300 relative z-10" data-id="element-66" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Opening Hook */}
      <section className="bg-gradient-to-b from-[#FAF6F0] via-[#F5EFE3] to-[#FAF6F0] px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-67">
        {/* Decorative background elements */}
        <div className="absolute top-10 left-10 md:left-20 opacity-[0.06] pointer-events-none" data-id="element-68">
          <MoonIcon className="w-32 h-32 md:w-40 md:h-40 text-[#1a2942]" strokeWidth={1} data-id="element-69" />
        </div>
        <div className="absolute bottom-16 right-10 md:right-24 opacity-[0.08] pointer-events-none" data-id="element-70">
          <SparklesIcon className="w-20 h-20 md:w-28 md:h-28 text-[#F5B461]" strokeWidth={1.5} data-id="element-71" />
        </div>
        <div className="absolute top-1/2 right-1/4 opacity-[0.05] pointer-events-none" data-id="element-72">
          <SparklesIcon className="w-10 h-10 text-[#1a2942]" strokeWidth={1.5} data-id="element-73" />
        </div>
        {/* Soft amber glow */}
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#F5B461]/10 rounded-full blur-3xl pointer-events-none" data-id="element-74"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-76">
            {/* Time stamp pill */}
            <div className="inline-flex items-center gap-2 bg-[#1a2942] text-[#F5B461] px-4 py-2 rounded-full mb-8 shadow-lg" data-id="element-77">
              <MoonIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-78" />
              <span className="text-xs font-bold tracking-[0.2em] uppercase" data-id="element-79">
                23:00 — Otra noche más
              </span>
            </div>

            {/* Decorative quote mark */}
            <div className="flex justify-center mb-2" data-id="element-80">
              <span className="font-['Fraunces'] text-7xl md:text-8xl text-[#F5B461] leading-none select-none" data-id="element-81">
                "
              </span>
            </div>

            {/* Main quote */}
            <blockquote className="font-['Fraunces'] text-2xl md:text-4xl leading-[1.4] text-[#1a2942] mb-10 px-2" data-id="element-82">
              Son las{' '}
              <span className="font-bold text-[#F5B461]" data-id="element-83">11 de la noche</span>.
              Estás agotada. Tu cuerpo no da más, pero tu hijo parece tener una{' '}
              <em className="italic" data-id="element-84">batería infinita</em>.
              <span className="block mt-3" data-id="element-85">
                Salta en la cama, corre por el pasillo y, aunque le rogás que se
                calme, parece que cuanto más cansado estás vos,{' '}
                <span className="underline decoration-[#F5B461] decoration-2 underline-offset-4" data-id="element-86">
                  más "eléctrico" se pone él
                </span>
                .
              </span>
            </blockquote>

            {/* Divider ornament */}
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-87">
              <div className="h-px w-12 bg-[#F5B461]/40" data-id="element-88"></div>
              <SparklesIcon className="w-4 h-4 text-[#F5B461]" data-id="element-89" />
              <div className="h-px w-12 bg-[#F5B461]/40" data-id="element-90"></div>
            </div>

            {/* Resolution paragraph */}
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-91">
              No es que no te escuche. No es que sea un niño "difícil". Es que
              su cerebro TDAH{' '}
              <span className="font-semibold text-[#1a2942]" data-id="element-92">
                no tiene freno de mano biológico
              </span>
              . Intentar que se duerma sin una estrategia es como pedirle a un
              tren de carga a 200km/h que frene en seco.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Los Dolores */}
      <section className="bg-gradient-to-b from-[#FAF6F0] to-[#FFFFFF] px-6 py-16 md:py-20" data-id="element-93">
        <div className="max-w-6xl mx-auto" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-95">
            <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-96">
              Si te pasa esto, no estás sola
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-97">
            {/* Image column */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="lg:sticky lg:top-8" data-id="element-98">
              <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(26,41,66,0.12)] border border-gray-100" data-id="element-99">
                <img src="https://cdn.magicpatterns.com/uploads/3yVwKL73aJEpe77Tgy5v8Y/mama_frustada.png" alt="Mamá agotada después de una noche difícil" className="w-full h-full object-cover" data-id="element-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a2942]/90 via-[#1a2942]/40 to-transparent pointer-events-none" data-id="element-101"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-102">
                  <p className="font-['Fraunces'] italic text-xl md:text-2xl text-white leading-snug" data-id="element-103">
                    "Sentís que ya no podés más, y nadie parece entenderlo."
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Dolores column */}
            <div className="space-y-4" data-id="element-104">
              {[{
              icon: MoonIcon,
              text: 'Llegan las 11 de la noche y él sigue saltando como si fueran las 4 de la tarde.'
            }, {
              icon: HeartCrackIcon,
              text: 'Te sentís culpable después de gritarle, pero ya no sabés qué más hacer.'
            }, {
              icon: AlertCircleIcon,
              text: 'Probaste melatonina, cuentos, masajes... y nada termina de funcionar.'
            }, {
              icon: FrownIcon,
              text: 'Discutís con tu pareja por la rutina del sueño todas las noches.'
            }, {
              icon: ZapIcon,
              text: 'Le das la tablet aunque sabés que está mal, porque es lo único que lo frena.'
            }, {
              icon: CoffeeIcon,
              text: 'Te quedás sin tu tiempo de descanso y al otro día arrancás reventada otra vez.'
            }].map((dolor, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.08
            }} className="flex gap-4 items-start bg-white p-5 rounded-xl shadow-[0_4px_20px_rgba(26,41,66,0.04)] border border-gray-100 hover:shadow-[0_8px_30px_rgba(26,41,66,0.08)] transition-shadow" data-id="element-105">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#F5B461]/10 rounded-full flex items-center justify-center" data-id="element-106">
                    <dolor.icon className="w-6 h-6 text-[#F5B461]" data-id="element-107" />
                  </div>
                  <p className="text-gray-700 leading-relaxed pt-2.5 text-base md:text-lg" data-id="element-108">
                    {dolor.text}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      {/* The Problem */}
      <section className="bg-gradient-to-b from-[#FFFFFF] to-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-109">
        <div className="max-w-4xl mx-auto" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_20px_50px_rgba(26,41,66,0.06)] border border-gray-100 relative overflow-hidden" data-id="element-111">
            {/* Decorative accent */}
            <div className="absolute top-0 left-0 w-2 h-full bg-[#F5B461]" data-id="element-112"></div>
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#F5B461]/10 rounded-full blur-2xl pointer-events-none" data-id="element-113"></div>

            <div className="flex items-center gap-4 mb-8" data-id="element-114">
              <div className="w-12 h-12 bg-[#F5B461]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-115">
                <AlertCircleIcon className="w-6 h-6 text-[#F5B461]" strokeWidth={2.5} data-id="element-116" />
              </div>
              <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold text-[#1a2942]" data-id="element-117">
                El Problema
              </h2>
            </div>

            <p className="text-lg md:text-xl leading-relaxed text-gray-600 mb-6" data-id="element-118">
              La mayoría de los padres cometen el error de intentar "forzar" la
              calma. Usan gritos, castigos o rutinas rígidas que solo logran
              estresar más el sistema nervioso del niño. En un cerebro con TDAH
              o TEA, el cansancio extremo no genera sueño; genera cortisol y más
              hiperactividad.
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-gray-600 font-medium" data-id="element-119">
              Por eso, cuanto más tarde se hace, más difícil es que se duerma.{' '}
              <span className="text-[#1a2942] bg-[#F5B461]/20 px-2 py-0.5 rounded" data-id="element-120">
                Estás luchando contra su biología, y es una batalla que nadie
                gana.
              </span>
            </p>
          </motion.div>
        </div>
      </section>

      {/* Why What You Tried Didn't Work */}
      <section className="bg-gradient-to-b from-[#FAF6F0] to-[#F5EFE3] px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-121">
        {/* Decorative blurred shapes */}
        <div className="absolute top-1/2 -left-32 w-72 h-72 bg-[#F5B461]/10 rounded-full blur-3xl pointer-events-none" data-id="element-122"></div>
        <div className="absolute bottom-0 -right-32 w-80 h-80 bg-[#1a2942]/5 rounded-full blur-3xl pointer-events-none" data-id="element-123"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-124">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-14 md:mb-16" data-id="element-125">
            <p className="text-xs md:text-sm font-bold tracking-[0.2em] text-[#F5B461] uppercase mb-4" data-id="element-126">
              La verdad incómoda
            </p>
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a2942] leading-tight mb-5 max-w-3xl mx-auto" data-id="element-127">
              Por qué lo que intentaste{' '}
              <span className="relative inline-block" data-id="element-128">
                <span className="relative z-10" data-id="element-129">no funcionó</span>
                <span className="absolute bottom-1 left-0 w-full h-3 bg-[#F5B461]/40 -z-0" data-id="element-130"></span>
              </span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-131">
              No es tu culpa. Estás peleando contra la biología de tu hijo con
              las herramientas equivocadas.
            </p>
          </motion.div>

          {/* 2x2 Grid */}
          <div className="grid md:grid-cols-2 gap-5 md:gap-6" data-id="element-132">
            {[{
            icon: BookOpenIcon,
            title: 'Los cuentos tradicionales',
            description: 'No funcionan porque su mente sigue buscando estímulo.'
          }, {
            icon: XIcon,
            title: "El 'quedate quieto'",
            description: 'Activa su sistema de alerta y genera más ansiedad.'
          }, {
            icon: ZapIcon,
            title: 'Las pantallas (celular/tablet)',
            description: 'Parecen calmarlo, pero en realidad sobreestimulan su cerebro con dopamina artificial, haciendo que el sueño sea de mala calidad.'
          }, {
            icon: CalendarIcon,
            title: 'Las rutinas rígidas',
            description: 'Fallan porque no tienen en cuenta el nivel de energía acumulada durante el día.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group relative bg-white p-7 md:p-8 rounded-2xl shadow-[0_8px_30px_rgba(26,41,66,0.06)] hover:shadow-[0_12px_40px_rgba(26,41,66,0.12)] hover:-translate-y-1 transition-all duration-300 border border-white" data-id="element-133">
                {/* "No funciona" badge in corner */}
                <div className="absolute top-4 right-4 flex items-center gap-1 bg-red-50 text-red-600 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wider uppercase" data-id="element-134">
                  <XIcon className="w-3 h-3" strokeWidth={3} data-id="element-135" />
                  <span data-id="element-136">No funciona</span>
                </div>

                {/* Icon */}
                <div className="relative mb-6 inline-flex" data-id="element-137">
                  <div className="absolute inset-0 bg-[#F5B461]/30 rounded-2xl blur-md" data-id="element-138"></div>
                  <div className="relative w-14 h-14 bg-gradient-to-br from-[#F5B461] to-[#e6a449] rounded-2xl flex items-center justify-center shadow-lg ring-4 ring-[#F5B461]/10" data-id="element-139">
                    <item.icon className="w-6 h-6 text-[#1a2942]" strokeWidth={2.5} data-id="element-140" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="font-['Fraunces'] font-bold text-xl md:text-2xl text-[#1a2942] mb-3 leading-tight pr-20" data-id="element-141">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed text-base" data-id="element-142">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          {/* Closing transition */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-center mt-14 md:mt-16 max-w-2xl mx-auto" data-id="element-143">
            <div className="flex items-center justify-center gap-3 mb-5" data-id="element-144">
              <div className="h-px w-12 bg-[#F5B461]/40" data-id="element-145"></div>
              <SparklesIcon className="w-4 h-4 text-[#F5B461]" data-id="element-146" />
              <div className="h-px w-12 bg-[#F5B461]/40" data-id="element-147"></div>
            </div>
            <p className="font-['Fraunces'] italic text-xl md:text-2xl text-[#1a2942] leading-relaxed" data-id="element-148">
              Lo que necesitás es un método pensado para{' '}
              <span className="font-bold text-[#F5B461] not-italic" data-id="element-149">
                su biología
              </span>
              , no contra ella.
            </p>
          </motion.div>
        </div>
      </section>

      {/* The Unique Mechanism - D.P.C. */}
      <section className="bg-gradient-to-b from-[#FFFFFF] to-[#FAF6F0] px-6 py-20 md:py-28" data-id="element-150">
        <div className="max-w-6xl mx-auto" data-id="element-151">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-152">
            <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-153">
              El Secreto del Éxito
            </p>
            <h2 className="font-['Fraunces'] text-4xl md:text-5xl font-bold mb-6 text-[#1a2942]" data-id="element-154">
              El Mecanismo Único
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-155">
              La clave es el Método D.P.C. (Descarga, Presión, Calma). En lugar
              de luchar contra la energía de tu hijo, la canalizamos. Este
              método utiliza una secuencia neuro-lógica que es la única forma de
              avisarle a un cerebro TDAH que es hora de apagarse.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-156">
            {[{
            letter: 'D',
            title: 'Descarga',
            description: 'Descargamos la dopamina motriz de forma segura y rápida',
            color: 'bg-[#F5B461]',
            image: 'https://cdn.magicpatterns.com/uploads/aeyTqzfwqCQE8HSBg3s4Ex/imagen_descarga.png'
          }, {
            letter: 'P',
            title: 'Presión',
            description: 'Organizamos el sistema nervioso mediante presión profunda, activando el sistema parasimpático',
            color: 'bg-[#F5B461]',
            image: 'https://cdn.magicpatterns.com/uploads/w1P68LYaKMXzTxv4yeEri8/imagen_presion.png'
          }, {
            letter: 'C',
            title: 'Calma',
            description: 'Anclamos la calma con actividades de baja intensidad',
            color: 'bg-[#F5B461]',
            image: 'https://cdn.magicpatterns.com/uploads/k4T9KJ3q8ziEE6FAyin3gf/imagen_calma.png'
          }].map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-white rounded-2xl text-center overflow-hidden flex flex-col shadow-[0_10px_40px_rgba(26,41,66,0.08)] border border-gray-100 hover:-translate-y-1 transition-transform duration-300" data-id="element-157">
                {step.image && <div className="w-full h-48 overflow-hidden" data-id="element-158">
                    <img src={step.image} alt={step.title} className="w-full h-full object-cover" data-id="element-159" />
                  </div>}
                <div className="p-8 flex-1 flex flex-col" data-id="element-160">
                  <div className={`${step.color} w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg ${step.image ? '-mt-16 border-4 border-white relative z-10' : ''}`} data-id="element-161">
                    <span className="font-['Fraunces'] text-5xl font-bold text-[#0F1B2D]" data-id="element-162">
                      {step.letter}
                    </span>
                  </div>
                  <h3 className="font-['Fraunces'] text-2xl font-bold mb-4 text-[#1a2942]" data-id="element-163">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-164">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* La Transformación */}
      <section className="bg-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-165">
        <div className="max-w-6xl mx-auto" data-id="element-166">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-14" data-id="element-167">
            <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-168">
              La Transformación
            </p>
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold text-[#1a2942]" data-id="element-169">
              Cómo cambia tu vida en 7 noches
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-[1fr_auto_1fr] gap-6 md:gap-4 items-stretch" data-id="element-170">
            {/* Antes */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white p-8 rounded-2xl shadow-md border-l-4 border-gray-300" data-id="element-171">
              <div className="flex items-center gap-3 mb-6" data-id="element-172">
                <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-173">
                  <FrownIcon className="w-5 h-5 text-gray-500" data-id="element-174" />
                </div>
                <h3 className="font-['Fraunces'] text-2xl font-bold text-gray-500" data-id="element-175">
                  Antes
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-176">
                {['2 horas de pelea para que se duerma', 'Gritos, llantos y portazos', 'Te dormís a las 1am agotada', 'Sentís culpa por perder la paciencia', 'Tu pareja y vos discuten por la rutina', 'Tu hijo despierta de mal humor'].map((item, i) => <li key={i} className="flex gap-3 items-start text-gray-600" data-id="element-177">
                    <XIcon className="w-5 h-5 flex-shrink-0 mt-0.5 text-gray-400" data-id="element-178" />
                    <span className="line-through decoration-gray-400" data-id="element-179">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            {/* Arrow */}
            <div className="flex items-center justify-center md:px-2" data-id="element-180">
              <motion.div initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="w-14 h-14 bg-[#F5B461] rounded-full flex items-center justify-center shadow-lg rotate-90 md:rotate-0" data-id="element-181">
                <ArrowRightIcon className="w-6 h-6 text-[#1a2942]" strokeWidth={3} data-id="element-182" />
              </motion.div>
            </div>

            {/* Después */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-[#1a2942] text-white p-8 rounded-2xl shadow-xl border-l-4 border-[#F5B461]" data-id="element-183">
              <div className="flex items-center gap-3 mb-6" data-id="element-184">
                <div className="w-10 h-10 bg-[#F5B461] rounded-full flex items-center justify-center" data-id="element-185">
                  <SunriseIcon className="w-5 h-5 text-[#1a2942]" data-id="element-186" />
                </div>
                <h3 className="font-['Fraunces'] text-2xl font-bold text-[#F5B461]" data-id="element-187">
                  Después
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-188">
                {['Se duerme en menos de 20 minutos', 'Rutina tranquila que disfrutan juntos', 'Recuperás tu noche y tu descanso', 'Volvés a sentirte buena mamá', 'Tu pareja se suma al proceso', 'Tu hijo despierta más regulado y feliz'].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-189">
                    <CheckIcon className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#F5B461]" strokeWidth={3} data-id="element-190" />
                    <span className="text-gray-100" data-id="element-191">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Los Beneficios */}
      <section className="bg-gradient-to-b from-[#FAF6F0] to-[#FFFFFF] px-6 py-16 md:py-20" data-id="element-192">
        <div className="max-w-6xl mx-auto" data-id="element-193">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-14" data-id="element-194">
            <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-195">
              Los Beneficios
            </p>
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold mb-4 text-[#1a2942]" data-id="element-196">
              Lo que vas a recuperar (vos también)
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-197">
              Esto no es solo sobre que tu hijo duerma. Es sobre devolverle paz
              a toda tu casa.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-[1.3fr_1fr] gap-8 lg:gap-12 items-start" data-id="element-198">
            {/* Benefits column */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 order-2 lg:order-1" data-id="element-199">
              {[{
              icon: MoonIcon,
              title: 'Recuperás tu descanso',
              desc: 'Volvés a tener tus 2-3 horas de noche sin gritos, sin tablets, sin culpa.'
            }, {
              icon: HeartIcon,
              title: 'Reconectás con tu hijo',
              desc: 'La rutina se vuelve un momento de juego y conexión, no una pelea diaria.'
            }, {
              icon: SmileIcon,
              title: 'Bajás tu propio cortisol',
              desc: 'Cuando él se regula, vos también. Menos estrés acumulado, más paciencia.'
            }, {
              icon: SparklesIcon,
              title: 'Tu hijo despierta mejor',
              desc: 'Mejor sueño = mejor humor, más foco en la escuela y menos berrinches.'
            }, {
              icon: BrainIcon,
              title: 'Entendés a tu hijo',
              desc: 'Aprendés a leer su sistema nervioso y dejás de luchar contra su biología.'
            }, {
              icon: HeartIcon,
              title: 'Tu pareja se suma',
              desc: 'Tener un método claro hace que ambos puedan participar sin discutir.'
            }].map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.08
            }} className="bg-white p-6 rounded-xl shadow-[0_4px_20px_rgba(26,41,66,0.04)] border border-gray-100 hover:shadow-[0_8px_30px_rgba(26,41,66,0.08)] hover:-translate-y-1 transition-all duration-300" data-id="element-200">
                  <div className="w-12 h-12 bg-[#F5B461]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-201">
                    <benefit.icon className="w-6 h-6 text-[#F5B461]" data-id="element-202" />
                  </div>
                  <h3 className="font-['Fraunces'] text-xl font-bold mb-2 text-[#1a2942]" data-id="element-203">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-204">
                    {benefit.desc}
                  </p>
                </motion.div>)}
            </div>

            {/* Image column */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="lg:sticky lg:top-8 order-1 lg:order-2" data-id="element-205">
              <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(26,41,66,0.12)] border border-gray-100" data-id="element-206">
                <img src="https://cdn.magicpatterns.com/uploads/cNWr79x7YF4Wjmooa3fJd2/imagen_beneficio.png" alt="Mamá tranquila después de aplicar el Método D.P.C." className="w-full h-full object-cover" data-id="element-207" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a2942]/90 via-[#1a2942]/40 to-transparent pointer-events-none" data-id="element-208"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-209">
                  <p className="font-['Fraunces'] italic text-xl md:text-2xl text-white leading-snug" data-id="element-210">
                    "Volvés a respirar. Volvés a vos."
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Middle CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-16 text-center" data-id="element-211">
            <motion.a href="https://www.energiaplena.com/cart/42798800404567:1" target="_blank" rel="noopener noreferrer" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="relative inline-flex items-center justify-center bg-gradient-to-r from-[#F5B461] to-[#f7c47d] text-[#0F1B2D] px-10 py-5 rounded-xl font-bold text-xl shadow-[0_0_40px_rgba(245,180,97,0.4)] hover:shadow-[0_0_60px_rgba(245,180,97,0.6)] transition-shadow w-full md:w-auto overflow-hidden group" data-id="element-212">
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-213"></div>
              <span className="relative z-10 flex items-center gap-2" data-id="element-214">
                ¡QUIERO EL MÉTODO D.P.C. AHORA!
              </span>
            </motion.a>
          </motion.div>
        </div>
      </section>

      {/* What You Get + Video */}
      <section className="bg-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-215">
        <div className="max-w-5xl mx-auto" data-id="element-216">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-16" data-id="element-217">
            <div className="text-center mb-10" data-id="element-218">
              <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-219">
                Un vistazo por dentro
              </p>
              <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold text-[#1a2942]" data-id="element-220">
                Qué Incluye el Método
              </h2>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-221">
            <div className="grid md:grid-cols-2 gap-6" data-id="element-222">
              {[{
              icon: BookOpenIcon,
              title: 'El Manual Maestro D.P.C.',
              description: '120 actividades detalladas paso a paso'
            }, {
              icon: BatteryChargingIcon,
              title: 'Fase D (40 ejercicios)',
              description: 'Para quemar la energía física de forma segura y rápida'
            }, {
              icon: BrainIcon,
              title: 'Fase P (40 ejercicios)',
              description: 'Técnicas de presión profunda para regular los sentidos'
            }, {
              icon: MoonIcon,
              title: 'Fase C (40 ejercicios)',
              description: 'Pequeños juegos de baja intensidad para cerrar el día'
            }, {
              icon: CalendarIcon,
              title: 'Hoja de Ruta 7 Días',
              description: 'El plan exacto para ver resultados desde la primera semana'
            }, {
              icon: FileTextIcon,
              title: 'Formato PDF',
              description: 'Para leer desde el celular mientras hacés las actividades'
            }].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-4 items-start bg-white p-6 rounded-lg shadow-md" data-id="element-223">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#F5B461] rounded-full flex items-center justify-center" data-id="element-224">
                    <item.icon className="w-6 h-6 text-[#1a2942]" data-id="element-225" />
                  </div>
                  <div data-id="element-226">
                    <h3 className="font-bold text-lg text-[#1a2942] mb-2" data-id="element-227">
                      {item.title}
                    </h3>
                    <p className="text-gray-700" data-id="element-228">{item.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Who This Is For / Not For */}
      <section className="bg-[#1a2942] text-white px-6 py-16 md:py-20" data-id="element-229">
        <div className="max-w-6xl mx-auto" data-id="element-230">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-231">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl" data-id="element-232">
              <h3 className="font-['Fraunces'] text-2xl font-bold mb-6 text-[#F5B461]" data-id="element-233">
                Para Quién Es Este Método
              </h3>
              <ul className="space-y-4" data-id="element-234">
                {['Padres de niños con TDAH o TEA (3 a 12 años) que sufren cada noche', 'Familias que necesitan herramientas prácticas y científicas para usar en casa', 'Padres que no tienen tiempo o presupuesto para materiales caros', 'Madres y padres que terminan el día agotados y necesitan recuperar su tiempo de descanso'].map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-235">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-236" />
                    <span className="text-gray-200" data-id="element-237">{item}</span>
                  </li>)}
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl" data-id="element-238">
              <h3 className="font-['Fraunces'] text-2xl font-bold mb-6 text-gray-400" data-id="element-239">
                Para Quién NO Es
              </h3>
              <ul className="space-y-4" data-id="element-240">
                {['Personas que buscan una cura mágica o instantánea sin involucrarse con su hijo', 'Quienes prefieren soluciones farmacológicas como única opción', 'Padres que no están dispuestos a dedicar 15 minutos de juego guiado por noche'].map((item, index) => <li key={index} className="flex gap-3 items-start" data-id="element-241">
                    <XIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-242" />
                    <span className="text-gray-400" data-id="element-243">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="bg-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-244">
        <div className="max-w-5xl mx-auto" data-id="element-245">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-246">
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold mb-12 text-[#1a2942] text-center" data-id="element-247">
              Cómo Funciona
            </h2>
            <div className="space-y-8" data-id="element-248">
              {[{
              number: '1',
              title: 'Identificás el nivel',
              description: "Mirás el 'Semáforo Sensorial' incluido para saber qué tan eléctrico está tu hijo"
            }, {
              number: '2',
              title: 'Aplicás la secuencia',
              description: 'Elegís una actividad de cada fase (D, P y C) del manual'
            }, {
              number: '3',
              title: 'Disfrutás los resultados',
              description: 'Ves cómo su cuerpo cede a la relajación de forma natural y sin peleas'
            }].map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-6 items-start bg-white p-6 rounded-lg shadow-md" data-id="element-249">
                  <div className="flex-shrink-0 w-16 h-16 bg-[#F5B461] rounded-full flex items-center justify-center" data-id="element-250">
                    <span className="font-['Fraunces'] text-3xl font-bold text-[#1a2942]" data-id="element-251">
                      {step.number}
                    </span>
                  </div>
                  <div data-id="element-252">
                    <h3 className="font-bold text-xl text-[#1a2942] mb-2" data-id="element-253">
                      {step.title}
                    </h3>
                    <p className="text-gray-700 text-lg" data-id="element-254">{step.description}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Proof / Believability */}
      <section className="bg-gradient-to-b from-[#0F1B2D] to-[#1a2942] text-white px-6 py-16 md:py-20" data-id="element-255">
        <div className="max-w-4xl mx-auto" data-id="element-256">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#F5B461] text-[#0F1B2D] p-10 md:p-16 rounded-2xl text-center shadow-2xl" data-id="element-257">
            <div className="flex justify-center mb-6" data-id="element-258">
              <ShieldCheckIcon className="w-16 h-16" data-id="element-259" />
            </div>
            <h3 className="font-['Fraunces'] text-3xl md:text-4xl font-bold mb-6" data-id="element-260">
              Resultados Comprobados
            </h3>
            <p className="text-xl md:text-2xl leading-relaxed" data-id="element-261">
              En solo <span className="font-bold" data-id="element-262">7 días</span>, la mayoría de
              los padres reportan que el tiempo de conciliación del sueño{' '}
              <span className="font-bold" data-id="element-263">se reduce a la mitad</span>.
            </p>
            <p className="mt-4 text-lg md:text-xl" data-id="element-264">
              No porque el niño "obedezca", sino porque su cuerpo finalmente
              recibió la señal biológica correcta para descansar.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <WhatsAppTestimonials data-id="element-265" />

      {/* Bonos */}
      <section className="bg-gradient-to-b from-[#FFFFFF] to-[#FAF6F0] px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-266">
        {/* Decorative spotlight */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#F5B461]/10 rounded-full blur-3xl pointer-events-none" data-id="element-267"></div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-268">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-269">
            <div className="inline-flex items-center gap-2 bg-[#F5B461]/10 text-[#F5B461] px-4 py-2 rounded-full mb-6 border border-[#F5B461]/20" data-id="element-270">
              <GiftIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-271" />
              <span className="text-xs font-bold tracking-widest uppercase" data-id="element-272">
                Pero eso no es todo
              </span>
            </div>
            <h2 className="font-['Fraunces'] text-3xl md:text-5xl font-bold mb-6 max-w-4xl mx-auto leading-tight text-[#1a2942]" data-id="element-273">
              <span className="text-[#F5B461]" data-id="element-274">Solo por hoy</span> te llevás los
              3 bonos exclusivos.{' '}
              <span className="block mt-2 text-2xl md:text-3xl text-gray-500 font-normal italic font-['Fraunces']" data-id="element-275">
                Mañana ya no van a estar disponibles.
              </span>
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-276">
              Que normalmente no están disponibles — y que juntos valen{' '}
              <span className="font-bold text-gray-400 line-through decoration-[#F5B461] decoration-2" data-id="element-277">
                $59.000 ARS
              </span>
              .{' '}
              <span className="font-bold text-[#F5B461]" data-id="element-278">
                Hoy son completamente GRATIS.
              </span>
            </p>

            {/* Main Mockup Image */}
            <div className="relative max-w-4xl mx-auto mb-16" data-id="element-279">
              <div className="absolute inset-0 bg-gradient-to-t from-[#FAF6F0] via-transparent to-transparent z-10 pointer-events-none" data-id="element-280"></div>
              <img src="https://cdn.magicpatterns.com/uploads/p24cbZqZKersSL3tShYP5M/mockup_con_los_bonos.png" alt="Método D.P.C. y todos los bonos exclusivos" className="w-full h-auto object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-281" />
            </div>
          </motion.div>

          {/* Bonus cards */}
          <div className="space-y-12 md:space-y-16" data-id="element-282">
            {[{
            num: '01',
            icon: LayoutDashboardIcon,
            title: 'Tablero Express de Noches en Calma',
            tagline: 'Tu hoja de ruta visual para los momentos de caos. Un solo vistazo y ya sabés qué hacer.',
            features: ['Tablero imprimible para pegar en la pared', 'Secuencia paso a paso del Método D.P.C.', 'Versión para días tranquilos y difíciles'],
            value: '$18.000 ARS',
            image: 'https://cdn.magicpatterns.com/uploads/afZgmFomxtWeiSkzYbY1tT/imagen_bono_1_nueva.png',
            reverse: false
          }, {
            num: '02',
            icon: RepeatIcon,
            title: 'Guía Rápida de Transiciones Sin Pelea',
            tagline: 'Estrategias concretas para que cada cambio de actividad fluya sin gritos.',
            features: ['10 estrategias de transición validadas', 'Frases exactas para cada cambio', 'Qué hacer cuando ya explotó'],
            value: '$22.000 ARS',
            image: 'https://cdn.magicpatterns.com/uploads/uCXL7f8WvfewiWd7LGYRsa/imagen_bono_2.png',
            reverse: true
          }, {
            num: '03',
            icon: ListChecksIcon,
            title: 'Checklist de Calma Nocturna en 5 Minutos',
            tagline: 'Una lista rápida y clara que te guía en menos de 5 minutos. Para que nunca pierdas el hilo.',
            features: ['Versión imprimible A4 y celular', 'Visual para que tu hijo lo siga solo', 'Espacio para anotar qué funcionó'],
            value: '$19.000 ARS',
            image: 'https://cdn.magicpatterns.com/uploads/d4J6Meu27onSVnt7qXuZDS/imagen_bono_3_nueva.png',
            reverse: false
          }].map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.7
          }} className="flex flex-col lg:flex-row bg-white rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(26,41,66,0.08)] border border-gray-100 hover:shadow-[0_30px_60px_rgba(26,41,66,0.12)] transition-shadow duration-300" data-id="element-283">
                {/* Image - takes 2/3 of the row, edge-to-edge */}
                <div className={`relative w-full lg:w-2/3 ${bonus.reverse ? 'lg:order-2' : ''}`} data-id="element-284">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover min-h-[300px] lg:min-h-[450px]" data-id="element-285" />
                  {/* GRATIS stamp */}
                  <div className={`absolute top-4 ${bonus.reverse ? 'left-4' : 'right-4'} md:top-6 md:${bonus.reverse ? 'left-6' : 'right-6'} bg-[#F5B461] text-[#0F1B2D] rounded-full w-24 h-24 md:w-28 md:h-28 flex flex-col items-center justify-center shadow-2xl rotate-12 border-4 border-white z-10`} data-id="element-286">
                    <span className="font-['Fraunces'] text-xl md:text-2xl font-bold leading-none" data-id="element-287">
                      GRATIS
                    </span>
                    <span className="text-[10px] md:text-xs font-bold tracking-wider mt-1" data-id="element-288">
                      HOY
                    </span>
                  </div>
                </div>

                {/* Content - takes 1/3 of the row */}
                <div className={`w-full lg:w-1/3 p-8 md:p-10 lg:p-12 flex flex-col justify-center ${bonus.reverse ? 'lg:order-1' : ''}`} data-id="element-289">
                  <div className="flex items-center gap-3 mb-5" data-id="element-290">
                    <div className="w-11 h-11 bg-[#F5B461]/10 rounded-lg flex items-center justify-center" data-id="element-291">
                      <bonus.icon className="w-5 h-5 text-[#F5B461]" strokeWidth={2.5} data-id="element-292" />
                    </div>
                    <span className="text-sm font-bold tracking-widest text-[#F5B461] uppercase" data-id="element-293">
                      Bono #{bonus.num}
                    </span>
                  </div>

                  <h3 className="font-['Fraunces'] text-2xl md:text-3xl font-bold mb-4 leading-tight text-[#1a2942]" data-id="element-294">
                    {bonus.title}
                  </h3>

                  <p className="text-gray-600 mb-6 leading-relaxed text-base" data-id="element-295">
                    {bonus.tagline}
                  </p>

                  <ul className="space-y-3 mb-8" data-id="element-296">
                    {bonus.features.map((feature, i) => <li key={i} className="flex gap-3 items-start" data-id="element-297">
                        <CheckIcon className="w-5 h-5 text-[#F5B461] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-298" />
                        <span className="text-gray-700 text-sm" data-id="element-299">{feature}</span>
                      </li>)}
                  </ul>

                  <div className="flex items-center gap-3 pt-5 border-t border-gray-100 mt-auto" data-id="element-300">
                    <span className="text-sm text-gray-500" data-id="element-301">Valor:</span>
                    <span className="text-base line-through text-gray-400 decoration-2" data-id="element-302">
                      {bonus.value}
                    </span>
                    <span className="ml-auto bg-[#F5B461]/10 text-[#F5B461] px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-303">
                      Hoy GRATIS
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Closing paragraph */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mt-16 max-w-3xl mx-auto text-center" data-id="element-304">
            <p className="text-gray-600 text-lg md:text-xl leading-relaxed mb-6" data-id="element-305">
              Estos 3 bonos no son relleno. Son las herramientas que hacen que
              el Método D.P.C. funcione desde el primer día.
            </p>
            <div className="text-left bg-white rounded-2xl p-8 shadow-[0_10px_40px_rgba(26,41,66,0.06)] border border-gray-100 my-8 space-y-4" data-id="element-306">
              <p className="text-gray-700 leading-relaxed text-lg" data-id="element-307">
                <span className="text-[#F5B461] font-bold" data-id="element-308">
                  Sin el Bono #1,
                </span>{' '}
                vas a improvisar en el peor momento — cuando más necesitás
                claridad.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg" data-id="element-309">
                <span className="text-[#F5B461] font-bold" data-id="element-310">
                  Sin el Bono #2,
                </span>{' '}
                las noches van a seguir empezando en crisis antes de que el
                método tenga oportunidad de actuar.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg" data-id="element-311">
                <span className="text-[#F5B461] font-bold" data-id="element-312">
                  Sin el Bono #3,
                </span>{' '}
                no vas a saber qué hiciste, qué funcionó ni cómo repetirlo
                mañana.
              </p>
            </div>
            <p className="font-['Fraunces'] italic text-xl md:text-2xl text-[#1a2942] leading-relaxed" data-id="element-313">
              Los tres juntos convierten el Método D.P.C. en algo que realmente
              podés sostener en el tiempo. Y hoy son completamente gratis cuando
              te llevás el Método.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 7-Day Guarantee */}
      <section className="bg-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-314">
        <div className="max-w-3xl mx-auto" data-id="element-315">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl shadow-xl p-10 md:p-14 text-center border-2 border-[#F5B461]/30 relative" data-id="element-316">
            <div className="flex justify-center mb-6" data-id="element-317">
              <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2,
              type: 'spring'
            }} className="w-56 h-56 md:w-72 md:h-72" data-id="element-318">
                <img src="https://cdn.magicpatterns.com/uploads/hiNFFWfLyZz8SKA7NsSLwZ/logo_garantia.png" alt="Garantía de 7 días - Compra sin riesgo" className="w-full h-full object-contain drop-shadow-xl" data-id="element-319" />
              </motion.div>
            </div>

            <p className="text-sm font-bold tracking-widest text-[#F5B461] uppercase mb-3" data-id="element-320">
              Garantía de Mamá Tranquila
            </p>
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold text-[#1a2942] mb-6" data-id="element-321">
              Probalo 7 noches sin riesgo
            </h2>

            <div className="text-lg text-gray-700 leading-relaxed space-y-4 max-w-2xl mx-auto" data-id="element-322">
              <p data-id="element-323">
                Sé exactamente cómo te sentís. Probaste mil cosas y nada
                funciona, así que es normal dudar antes de invertir en algo
                nuevo.
              </p>
              <p data-id="element-324">
                Por eso quiero que estés{' '}
                <span className="font-bold text-[#1a2942]" data-id="element-325">100% tranquila</span>
                : aplicá el Método D.P.C. con tu hijo durante 7 noches. Si no
                ves un cambio real en cómo se duerme, escribime y te devuelvo
                cada peso. Sin preguntas, sin trámites raros, sin letra chica.
              </p>
              <p className="font-['Fraunces'] italic text-xl text-[#1a2942] pt-2" data-id="element-326">
                El único riesgo es que tu familia recupere el descanso que se
                merece.
              </p>
            </div>

            <motion.a href="https://www.energiaplena.com/cart/42798800404567:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block mt-8 bg-[#1a2942] text-white px-8 py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-[#0F1B2D] transition-colors" data-id="element-327">
              Quiero Probarlo Sin Riesgo
            </motion.a>
          </motion.div>
        </div>
      </section>

      {/* Oferta */}
      <section id="oferta" className="bg-gradient-to-b from-[#FFFFFF] to-[#FAF6F0] px-6 py-20 md:py-28 relative overflow-hidden" data-id="element-328">
        {/* Soft background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#F5B461]/10 rounded-full blur-3xl pointer-events-none" data-id="element-329"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-330">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-14 rounded-3xl text-center shadow-[0_20px_60px_rgba(26,41,66,0.08)] border border-gray-100" data-id="element-331">
            <div className="inline-flex items-center gap-2 bg-[#F5B461]/10 text-[#F5B461] px-4 py-2 rounded-full mb-6 border border-[#F5B461]/20" data-id="element-332">
              <StarIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-333" />
              <span className="text-xs font-bold tracking-widest uppercase" data-id="element-334">
                Oferta Especial
              </span>
            </div>
            <h2 className="font-['Fraunces'] text-3xl md:text-5xl font-bold mb-4 text-[#1a2942]" data-id="element-335">
              Todo lo que te llevás hoy
            </h2>

            {/* New Mockup Image */}
            <div className="mb-10 flex justify-center" data-id="element-336">
              <img src="https://cdn.magicpatterns.com/uploads/r4G4RXF9WifPFxoEqsBWod/mockup_con_los_bonos.png" alt="Método D.P.C. y todos los bonos" className="w-full max-w-2xl mx-auto h-auto object-contain drop-shadow-2xl" data-id="element-337" />
            </div>

            {/* Total + Price */}
            <div className="mb-8" data-id="element-338">
              <div className="flex items-center justify-center gap-3 text-gray-500 mb-2" data-id="element-339">
                <span className="text-base md:text-lg" data-id="element-340">Valor total:</span>
                <span className="text-xl md:text-2xl font-bold line-through decoration-[#F5B461] decoration-2" data-id="element-341">
                  $74.800 ARS
                </span>
              </div>
              <p className="text-sm text-gray-500 mb-2 font-medium uppercase tracking-widest" data-id="element-342">
                Hoy lo llevás por:
              </p>
              <div className="text-6xl md:text-7xl font-bold text-[#1a2942] mb-6" data-id="element-343">
                $14.900 <span className="text-3xl text-gray-400" data-id="element-344">ARS</span>
              </div>
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-345">
                Menos de lo que cuesta una cena rápida, pero con un impacto que
                va a cambiar la dinámica de toda tu familia para siempre.
              </p>
            </div>

            {/* Countdown Timer */}
            <div className="mb-10 bg-gray-50 rounded-2xl border border-gray-100 p-6 md:p-8 shadow-inner" data-id="element-346">
              <div className="text-center mb-6" data-id="element-347">
                <div className="inline-block bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase mb-3" data-id="element-348">
                  Oferta solo por hoy
                </div>
                <p className="text-sm md:text-base text-gray-600 font-medium leading-relaxed max-w-lg mx-auto" data-id="element-349">
                  Tu lugar solo está reservado por{' '}
                  <span className="font-bold text-[#1a2942]" data-id="element-350">10 minutos</span>.
                  En caso de no acceder, se cederá a otra persona.
                </p>
              </div>

              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-351">
                <span className="relative flex h-2.5 w-2.5" data-id="element-352">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-353"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-354"></span>
                </span>
                <p className="text-xs md:text-sm font-bold tracking-widest text-[#1a2942] uppercase" data-id="element-355">
                  La oferta termina en:
                </p>
              </div>

              <div className="flex items-center justify-center gap-3 md:gap-4 mb-6" data-id="element-356">
                {[{
                value: timeLeft.minutes,
                label: 'Min'
              }, {
                value: timeLeft.seconds,
                label: 'Seg'
              }].map((unit, i) => <Fragment key={i} data-id="element-357">
                    <div className="flex flex-col items-center" data-id="element-358">
                      <div className="bg-white text-[#1a2942] font-['Fraunces'] font-bold text-4xl md:text-5xl rounded-xl w-20 md:w-24 h-20 md:h-24 flex items-center justify-center shadow-[0_8px_30px_rgba(26,41,66,0.08)] border border-gray-100 tabular-nums" data-id="element-359">
                        {String(unit.value).padStart(2, '0')}
                      </div>
                      <span className="text-[10px] md:text-xs font-bold tracking-widest text-gray-500 uppercase mt-3" data-id="element-360">
                        {unit.label}
                      </span>
                    </div>
                    {i === 0 && <span className="text-gray-300 font-['Fraunces'] font-bold text-4xl md:text-5xl -mt-8" data-id="element-361">
                        :
                      </span>}
                  </Fragment>)}
              </div>

              <div className="text-center" data-id="element-362">
                <span className="inline-block bg-[#F5B461]/20 text-[#1a2942] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide" data-id="element-363">
                  ¡Ahorrá el 80%!
                </span>
              </div>
            </div>

            <motion.a href="https://www.energiaplena.com/cart/42798800404567:1" target="_blank" rel="noopener noreferrer" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="relative inline-flex items-center justify-center bg-gradient-to-r from-[#F5B461] to-[#f7c47d] text-[#0F1B2D] px-10 py-5 rounded-xl font-bold text-xl shadow-[0_0_40px_rgba(245,180,97,0.4)] hover:shadow-[0_0_60px_rgba(245,180,97,0.6)] transition-shadow mb-4 w-full md:w-auto overflow-hidden group" data-id="element-364">
              {/* Shine effect */}
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-365"></div>
              <span className="relative z-10 flex items-center gap-2" data-id="element-366">
                ¡QUIERO EL MÉTODO D.P.C. AHORA!
              </span>
            </motion.a>
            <div className="flex items-center justify-center gap-2 text-gray-500 mt-4" data-id="element-367">
              <DownloadIcon className="w-5 h-5" data-id="element-368" />
              <span data-id="element-369">Pago seguro y descarga inmediata en tu celular</span>
            </div>
          </motion.div>

          {/* Métodos de pago seguros */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mt-10 max-w-2xl mx-auto" data-id="element-370">
            <div className="bg-white rounded-3xl border border-gray-100 p-6 md:p-8 shadow-[0_10px_40px_rgba(26,41,66,0.06)]" data-id="element-371">
              {/* Header */}
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-372">
                <div className="w-8 h-8 bg-[#F5B461]/10 rounded-full flex items-center justify-center" data-id="element-373">
                  <LockIcon className="w-4 h-4 text-[#F5B461]" strokeWidth={2.5} data-id="element-374" />
                </div>
                <p className="text-sm md:text-base font-bold tracking-widest text-[#1a2942] uppercase" data-id="element-375">
                  Pago 100% seguro
                </p>
              </div>

              {/* Payment logos inner card */}
              <div className="bg-gray-50 rounded-2xl px-6 py-5 mb-6 border border-gray-100" data-id="element-376">
                <img src="https://cdn.magicpatterns.com/uploads/1CY3wmbZHBeiJjK2KDAufo/Diseno_sin_titulo_(20)_(2).png" alt="Pago seguro garantizado — Visa, Mastercard, Maestro, Mercado Pago" className="w-full h-auto object-contain" data-id="element-377" />
              </div>

              {/* Trust signals */}
              <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-gray-600 font-medium" data-id="element-378">
                <div className="flex items-center gap-2" data-id="element-379">
                  <ShieldCheckIcon className="w-5 h-5 text-[#F5B461]" data-id="element-380" />
                  <span data-id="element-381">Encriptado SSL</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-382">
                  <DownloadIcon className="w-5 h-5 text-[#F5B461]" data-id="element-383" />
                  <span data-id="element-384">Descarga inmediata</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-385">
                  <BadgeCheckIcon className="w-5 h-5 text-[#F5B461]" data-id="element-386" />
                  <span data-id="element-387">Garantía 7 días</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#FAF6F0] px-6 py-16 md:py-20" data-id="element-388">
        <div className="max-w-4xl mx-auto" data-id="element-389">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-390">
            <h2 className="font-['Fraunces'] text-3xl md:text-4xl font-bold mb-12 text-[#1a2942] text-center" data-id="element-391">
              Preguntas Frecuentes
            </h2>
            <div className="space-y-4" data-id="element-392">
              {[{
              question: '¿Necesito materiales caros?',
              answer: 'No, usás lo que tenés en casa: almohadones, mantas y tu propia interacción.'
            }, {
              question: '¿Cuánto tiempo toma?',
              answer: 'Entre 15 y 20 minutos por noche.'
            }, {
              question: '¿Sirve para niños sin diagnóstico pero muy inquietos?',
              answer: 'Absolutamente, el método regula cualquier sistema nervioso sobreestimulado.'
            }, {
              question: '¿Cómo recibo el material?',
              answer: 'Es un PDF de descarga inmediata en tu email.'
            }].map((faq, index) => <motion.div key={index} initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-393">
                  <button onClick={() => toggleFaq(index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-394">
                    <span className="font-bold text-lg text-[#1a2942]" data-id="element-395">
                      {faq.question}
                    </span>
                    <motion.div animate={{
                  rotate: openFaq === index ? 180 : 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-396">
                      <svg className="w-6 h-6 text-[#F5B461]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-397">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-398" />
                      </svg>
                    </motion.div>
                  </button>
                  <motion.div initial={false} animate={{
                height: openFaq === index ? 'auto' : 0,
                opacity: openFaq === index ? 1 : 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-399">
                    <div className="px-6 pb-4 text-gray-700" data-id="element-400">{faq.answer}</div>
                  </motion.div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F1B2D] text-gray-400 px-6 py-8 border-t border-gray-800" data-id="element-401">
        <div className="max-w-6xl mx-auto text-center" data-id="element-402">
          <p className="text-sm" data-id="element-403">
            © 2026 Método D.P.C. Todos los derechos reservados.
          </p>
          <p className="text-xs mt-2" data-id="element-404">
            Este producto es un recurso educativo y no reemplaza el consejo
            médico profesional.
          </p>
        </div>
      </footer>
    </div>;
}